import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

// CONFIGURAÇÃO DE COSTUMIZAÇÃO

Vue.prototype.$produtos_categorias = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      categoriasAddEdit: "new",
      categorias_loading: false,
      cadastro: {
        isHomeMkt: false,
        isTwoRows: false,
        idcategoria: "",
        loading: false,
        descricao_pt_br: "",
        descricao_en_us: "",
        descricao_es_es: "",
        tem_traducao: false,
        ordem: "",
        status: "",
        icone: { imagem: null, have: false },
        banner: { imagem: null, have: false },
        descritivo_pt_br: "",
        descritivo_en_us: "",
        descritivo_es_es: "",
        error: {
          descricao_pt_br: [],
          ordem: [],
          status: [],
          icone: [],
          banner: [],
        },
      },
      categorias: [],
      filtros: [],
      filtro_loading: false,
      filter: {
        descricao: "",
        status: "",
      },
      text: "",
      funcao: "",
    };
  },

  methods: {
    // ---- LISTAR CATEGORIAS ---- //
    getCategorias() {
      this.cadastro.loading = true;
      this.$axios.post(this.ENDPOINTS.LISTAR_CATEGORIAS).then(response => {
        if (response) {
          this.categorias = response;
          this.cadastro.loading = false;
        }
        // this.$axios.setLocal('categorias-produtos', response)
      });
    },

    // ---- DELETAR CATEGORIAS ---- //
    deletarCategoria(idcategoria) {
      this.$axios
        .delete(this.ENDPOINTS.DELETAR_CATEGORIA + idcategoria)
        .then(() => {
          this.getCategorias();
        });
    },

    // ---- ALTERAR CATEGORIAS ---- //
    alterarCategoria() {
      this.cadastro.loading = true;
      let dados = {
        descricao: `<pt_BR>${this.cadastro.descricao_pt_br}</pt_BR><en_US>${this.cadastro.descricao_en_us}</en_US><es_ES>${this.cadastro.descricao_es_es}</es_ES>`,
        ativo: Number.parseInt(this.cadastro.status),
        ordem: Number.parseInt(this.cadastro.ordem),
        icone: this.cadastro.icone.imagem,
        is_marketplace: this.cadastro.isHomeMkt,
        is_two_rows: this.cadastro.isTwoRows,
        banner: this.cadastro.banner.imagem,
        descritivo: `<pt_BR>${this.cadastro.descritivo_pt_br}</pt_BR><en_US>${this.cadastro.descritivo_en_us}</en_US><es_ES>${this.cadastro.descritivo_es_es}</es_ES>`,
        slug: this.transformToSlug(this.cadastro.descricao_pt_br),
      };

      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_CATEGORIA + this.cadastro.idcategoria,
          dados
        )
        .then(response => {
          if (response) {
            this.$axios.setLocal("confirmEditProductCategory", true);
            // dados cadastrais
            this.cadastro.descricao_pt_br = "";
            this.cadastro.descricao_en_us = "";
            this.cadastro.descricao_es_es = "";
            this.cadastro.isHomeMkt = false;
            this.cadastro.isTwoRows = false;
            (this.cadastro.status = ""),
              (this.cadastro.ordem = ""),
              (this.cadastro.icone.imagem = ""),
              delete this.cadastro.icone.object;
            (this.cadastro.icone.have = ""),
              (this.cadastro.banner.imagem = ""),
              delete this.cadastro.banner.object,
              (this.cadastro.banner.have = ""),
              (this.cadastro.descritivo_pt_br = "");
            this.cadastro.descritivo_en_us = "";
            this.cadastro.descritivo_es_es = "";
            document.getElementsByClassName(
              "modal-body-produtos-categorias"
            )[0].style.display = "none";
            this.getCategorias();
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- CADASTRAR CATEGORIAS ---- //
    async cadastrarCategoria() {
      this.cadastro.loading = true;
      let dados = {
        descricao: `<pt_BR>${this.cadastro.descricao_pt_br}</pt_BR><en_US>${this.cadastro.descricao_en_us}</en_US><es_ES>${this.cadastro.descricao_es_es}</es_ES>`,
        ativo: Number.parseInt(this.cadastro.status),
        ordem: Number.parseInt(this.cadastro.ordem),
        icone: this.cadastro.icone.imagem,
        banner: this.cadastro.banner.imagem,
        is_marketplace: this.cadastro.isHomeMkt,
        is_two_rows: this.cadastro.isTwoRows,
        descritivo: `<pt_BR>${this.cadastro.descritivo_pt_br}</pt_BR><en_US>${this.cadastro.descritivo_en_us}</en_US><es_ES>${this.cadastro.descritivo_es_es}</es_ES>`,
        slug: this.transformToSlug(this.cadastro.descricao_pt_br),
      };

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_CATEGORIA, dados)
        .then(response => {
          if (response) {
            // dados cadastrais
            this.cadastro.descricao_pt_br = "";
            this.cadastro.descricao_en_us = "";
            this.cadastro.descricao_es_es = "";
            this.cadastro.isHomeMkt = false;
            this.cadastro.isTwoRows = false;
            (this.cadastro.status = ""),
              (this.cadastro.ordem = ""),
              (this.cadastro.icone.imagem = ""),
              delete this.cadastro.icone.object,
              (this.cadastro.icone.have = false),
              (this.cadastro.banner.imagem = ""),
              delete this.cadastro.banner.object,
              (this.cadastro.banner.have = false),
              (this.cadastro.descritivo_pt_br = "");
            this.cadastro.descritivo_en_us = "";
            this.cadastro.descritivo_es_es = "";
            document.getElementsByClassName(
              "modal-body-produtos-categorias"
            )[0].style.display = "none";
            this.getCategorias();
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    /**
     * @description Método para abrir o modal de confirmação de remoção da categoria
     * @param {id} String - ID da categoria a ser removida
     * @param {msg} String - Mensagem de confirmação da remoção da categoria
     */
    remover(id, msg) {
      this.$config.modalConfirm = true;
      this.text = msg;
      this.cadastro.idcategoria = id;
    },

    /**
     * @description Método de confirmação de remoção de categoria
     */
    funcaoRemover() {
      this.deletarCategoria(this.cadastro.idcategoria);
    },

    filtroCategoria() {
      this.filtros = [];
      this.filtro_loading = true;

      if (this.filter.descricao !== "" && this.filter.descricao !== null) {
        this.filtros.push({
          campo: "descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.descricao,
        });
      }

      if (this.filter.status !== "" && this.filter.status !== null) {
        this.filtros.push({
          campo: "ativo",
          tipo: "int",
          orientacao: "=",
          valor: this.filter.status,
        });
      }

      let filtered = this.filtros;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_CATEGORIAS,
          JSON.stringify({
            loja: this.$axios.getLocal("produtos_categorias_loja_selecionada")
              .data,
            filtros: filtered,
          })
        )
        .then(response => {
          this.categorias = response;
          this.filtro_loading = false;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    /**
     * @description Método de validação das informações de cadastro e alteração das categorias
     */
    async validarCadastro() {
      if (this.cadastro.ordem === "") {
        this.$config.alert(
          "Preencha a ordem da categoria corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.ordem =
          "Preencha a ordem da categoria corretamente!";
        return;
      }

      if (this.cadastro.status === "") {
        this.$config.alert(
          "Selecione o status da categoria!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.status = "Selecione o status da categoria!";
        return;
      }

      if (this.cadastro.descricao_pt_br === "") {
        this.$config.alert(
          "Preencha a descrição corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.descricao_pt_br =
          "Preencha a descrição corretamente!";
        return;
      }

      if (this.cadastro.icone.imagem == null) {
        this.$config.alert(
          "Selecione um icone para a categoria!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.icone = "Selecione um icone para a categoria!";
        return;
      }

      if (this.cadastro.banner.imagem == null) {
        this.$config.alert(
          "Selecione um banner para a categoria!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.banner = "Selecione um banner para a categoria!";
        return;
      }

      if (this.categoriasAddEdit == "edit") {
        this.alterarCategoria();
        return;
      }

      this.cadastrarCategoria();
    },
    transformToSlug(str) {
      return String(str)
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
    limpaFormularioDeCategoriaProduto() {
      this.cadastro.descricao_pt_br = "";
      this.cadastro.descricao_en_us = "";
      this.cadastro.descricao_es_es = "";
      this.cadastro.tem_traducao = false;
      this.cadastro.ordem = "";
      this.cadastro.isHomeMkt = false;
      this.cadastro.isTwoRows = false;
      this.cadastro.status = "";
      this.cadastro.icone = [];
      this.cadastro.banner = [];
      this.cadastro.descritivo_pt_br = "";
      this.cadastro.descritivo_en_us = "";
      this.cadastro.descritivo_es_es = "";
      this.cadastro.error.descricao_pt_br = "";
      this.cadastro.error.ordem = "";
      this.cadastro.error.status = "";
      this.cadastro.error.icone = "";
      this.cadastro.error.banner = "";
    },

    limpaFiltros() {
      this.filter.descricao = "";
      this.filter.status = "";
      this.filtros = [];
    },
  },
});
